export const HTTP_FORBIDDEN = 403
export const HTTP_NOT_FOUND = 404
